// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"p6-z","displaySixCardTiles":"q6-z"};